module.exports = __webpack_public_path__ + "img/consent-collection-widget-top-left.22bfc65a.svg";